// import api from 'st-app/api';
// import { SessionConstants } from 'st-api/stApp';
// import { createStore } from 'solid-js/store';

// const [constants, setConstants] = createStore(new SessionConstants());
// api.GetSessionConstants().then(setConstants);

export const Constants = {} as Record<string, any>;
